import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencyPipeModule } from '../../shared/modules/currency-pipe/currency-pipe.module';
import { CaptionLabelModule } from '../caption-label/caption-label.module';
import { DescriptionModule } from '../description/description.module';
import { ReceiptComponent } from './receipt.component';

@NgModule({
  declarations: [ReceiptComponent],
  imports: [
    CommonModule,
    CaptionLabelModule,
    DescriptionModule,
    CurrencyPipeModule,
  ],
  exports: [ReceiptComponent],
})
export class ReceiptModule {}
